import React from "react";

import { cn } from "../../utils/cn";

type BrandLockupProps = {
  className?: string;
  inline?: boolean;
  light?: boolean;
};

export function BrandLockup({ className, inline = false, light = false }: BrandLockupProps) {
  return (
    <div data-motion="brand" className={cn("section-brand", inline && "section-brand-inline", light && "section-brand-light", className)}>
      <span className="section-brand-name"><b className="type-display">Conversas</b><i className="type-voice">Terapêuticas</i></span>
      <span className="type-voice section-brand-author">por Manuela Xavier</span>
    </div>
  );
}
